import React from "react";
import {
  DialogContainer,
  DialogHeader,
  DialogTitle,
  PlayerSelection,
  SelectionText,
  PlayerRow,
  PlayerProfile,
  ForfeitWarning,
  Buttons,
  Success,
  Text
} from "./styled";
import { propValueOr, getUsername } from "../../../helpers/common";
import DialogKit from "../../../components/kit/Dialog/DialogKit";
import ButtonKit from "../../../components/kit/Button/ButtonKit";
import RadioButtonKit from "../../../components/kit/Fields/RadioButton/RadioButtonKit";
import placeholderUserImg from "../../../static/images/default-user.jpg";
import { api } from "../../../index";
import iconCheck from "../../../static/icons/circle-check-green.svg";
import iconX from "../../../static/icons/circle-x-red.svg";
class ForfeitDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedIndex: null,
      forfeitPlayer: null,
      success: false,
      error: ""
    };
  }

  handleCheckboxClick(player, index) {
    this.setState({ checkedIndex: index, forfeitPlayer: player });
  }

  handleForfeit = () => {
    if (this.state.forfeitPlayer) {
      api.admin.matches
        .update(this.props.game.token, {
          forfeit: true,
          userId: this.state.forfeitPlayer.id
        })
        .then(resp => this.setState({ success: true }))
        .catch(err =>
          this.setState({
            error: propValueOr(
              err,
              "response.data.message",
              err.message || "Unknown error. Please Try again later."
            )
          })
        );
    }
  };

  renderSuccess = () => {
    const { error } = this.state;
    return (
      <DialogContainer>
        <DialogHeader>
          <DialogTitle>
            {error ? "Score Change Failed" : "Success!"}
          </DialogTitle>
        </DialogHeader>
        <Success>
          <img
            src={error ? iconX : iconCheck}
            width={65}
            height={65}
            alt="check"
          />
          <Text>{error || "The scores have been updated."}</Text>
        </Success>
        <Buttons>
          <ButtonKit
            fullWidth
            onClick={() =>
              error
                ? this.setState({
                    error: null,
                    homeScore: "",
                    awayScore: "",
                    success: false
                  })
                : this.handleClose()
            }
            color={error ? "primary" : "green"}
          >
            {error ? "Try Again" : "Okay"}
          </ButtonKit>
        </Buttons>
      </DialogContainer>
    );
  };

  handleClose = () => {
    const { onClose } = this.props;

    this.setState({ forfeitPlayer: null, checkedIndex: null, success: false });
    onClose();
  };

  renderDialog = () => {
    const { players, onClose, teams } = this.props;
    const { checkedIndex, forfeitPlayer } = this.state;
    return (
      <DialogContainer>
        <DialogHeader>
          <DialogTitle>Forfeit {teams ? "Team" : "Player"}</DialogTitle>
        </DialogHeader>
        <PlayerSelection>
          <SelectionText>
            Select a {teams ? "team" : "player"} to forfeit
          </SelectionText>
          {players.map((player, index) => (
            <PlayerRow>
              <RadioButtonKit
                value={checkedIndex === index}
                checked={checkedIndex === index}
                onChange={() => this.handleCheckboxClick(player, index)}
              />
              <PlayerProfile
                src={
                  teams
                    ? propValueOr(player, "team.imageInfo.thumbnail", {})
                    : propValueOr(player, "imageInfo.thumbnail", {})
                }
                onError={e => (e.target.src = placeholderUserImg)}
              />
              {teams
                ? propValueOr(player, "team.name", getUsername(player))
                : getUsername(player)}
            </PlayerRow>
          ))}
          <ForfeitWarning>
            <span className="warning">Warning:</span> This action cannot be
            undone. Once a {teams ? "team" : "player"} has been forfeited, they
            will lose the game and be given a loss.
          </ForfeitWarning>
        </PlayerSelection>
        <Buttons>
          <ButtonKit
            disabled={!forfeitPlayer}
            onClick={this.handleForfeit}
            fullWidth
            color={"red"}
          >
            Submit
          </ButtonKit>
          <ButtonKit fullWidth appearance={"secondary"} onClick={onClose}>
            Cancel
          </ButtonKit>
        </Buttons>
      </DialogContainer>
    );
  };

  render() {
    const { isOpen } = this.props;
    return (
      <DialogKit
        isOpen={isOpen}
        onClose={this.handleClose}
        renderCustom={
          this.state.success || this.state.error
            ? this.renderSuccess
            : this.renderDialog
        }
        displayButtonClose={false}
      />
    );
  }
}

export default ForfeitDialog;
